import { atom, PrimitiveAtom } from "jotai";
import { merge, get } from "lodash";

export function localStorageAtom(
    key: string,
    initialValue: string | null = null,
) {
    const atomBase = atom<string | null>(
        localStorage.getItem(key) ?? initialValue,
    );

    return atom(
        (get) => get(atomBase),
        (get, set, newStr: string) => {
            set(atomBase, newStr);
            localStorage.setItem(key, newStr);
        },
    );
}

// for storing object state that can be merged to instead of replaced
export function mergeableAtom<T>(
    baseAtom: PrimitiveAtom<Partial<T>>,
    parseFn?: (update: Partial<T>) => Partial<T>,
) {
    return atom(
        (get) => get(baseAtom),
        (get, set, update: Partial<T>) => {
            let nextUpdate = update;
            if (parseFn) {
                nextUpdate = parseFn(update);
            }
            set(baseAtom, merge({}, get(baseAtom), nextUpdate));
        },
    );
}

export function hasPopulatedFields<T extends object>(
    object: T = {} as T,
    keys: string[],
) {
    return keys.every((key) => {
        const value = get(object, key);
        return value !== undefined && value !== null && value !== "";
    });
}
